module.exports = __webpack_public_path__ + "static/img/wxbg.fd8a147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxbg.jpg
// module id = QRaa
// module chunks = 128